import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_USER_SETTINGS = `${BASE_URL}/api/user-settings`;

export class UserSettingsApi {
  static async fetchUserSettings() {
    return (await axiosInstance.get(`${BASE_URL_USER_SETTINGS}`)).data;
  }

  static async updateUserSettings(householdSize, weekStartDay) {
    const response = await axiosInstance.put(`${BASE_URL_USER_SETTINGS}`, {
      householdSize,
      weekStartDay,
    });
    return response.data;
  }
}
